import { useState } from 'react';
import { testimonials } from '@/mocks/home';

export default function TestimonialSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const current = testimonials[currentIndex];

  const goNext = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const goPrev = () => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 text-center mb-14">
          💬 读者口碑
        </h2>

        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
          <div className="w-48 h-48 md:w-56 md:h-56 flex-shrink-0 rounded-3xl overflow-hidden bg-accent-100">
            <img
              src={current.avatar}
              alt={current.name}
              title={`${current.name} - 韩漫漫画网读者`}
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1">
            <p className="text-xs font-medium text-accent-600 uppercase tracking-wide mb-2">
              （读者评价）
            </p>
            <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
              最懂我<span className="text-foreground-300">的韩漫平台</span>
            </h3>
            <blockquote className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 border-l-3 border-accent-300 pl-5">
              "{current.content}"
            </blockquote>
            <p className="text-sm font-semibold text-foreground-800">
              — {current.name}，{current.role}
            </p>

            <div className="flex items-center gap-3 mt-8">
              <button
                onClick={goPrev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:text-foreground-700 hover:border-foreground-400 cursor-pointer transition-colors"
                aria-label="上一条评价"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={goNext}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-white hover:bg-accent-600 cursor-pointer transition-colors"
                aria-label="下一条评价"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <div className="flex items-center gap-1.5 ml-2">
                {testimonials.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentIndex(idx)}
                    className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                      idx === currentIndex ? 'bg-accent-500 w-6' : 'bg-foreground-200 hover:bg-foreground-300'
                    }`}
                    aria-label={`第${idx + 1}条评价`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}